import { SHOW_CONNECT_BUTTONS } from '../constants/actions';

const DEFAULT_HOMEPAGE_STATE = {
  accepted_terms: false,
  email_pass_mode: false,
  sign_in_mode: false,
  showConnectButtons: false,
};

const homepageReducer = (state = DEFAULT_HOMEPAGE_STATE, action) => {
  switch (action.type) {
    case SHOW_CONNECT_BUTTONS:
      return {
        ...state,
        showConnectButtons: true,
      };

    default:
      return state;
  }
};

export default homepageReducer;
